// src/components/answering-traveller-questions-content-search/answering-traveller-questions-content-search.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    egdsElementId\n    graphic {\n      ...EGDSIconFragment\n    }\n    impressionAnalytics {\n      event\n      linkName\n      referrerId\n    }\n    size\n    text\n    theme\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment TravellerClickActionFragment on TravellerClickAction {\n    clickEvent {\n      eventName\n      eventType\n      eventVersion\n      actionLocation\n    }\n    clickAnalytics {\n      referrerId\n      eventType\n      linkName\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment DialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment ErrorMessageFragment on EGDSErrorSummary {\n    heading\n    body {\n      ... on EGDSGraphicText {\n        text\n        graphic {\n          ...EGDSIconFragment\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    accessibility\n    disabled\n    icon {\n      ...EGDSIconFragment\n    }\n    primary\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchDialogCTAFragment on TravellerSearchDialogCTA {\n    button {\n      ...EGDSButtonFragment\n    }\n    targetRef\n    impressionAnalytics {\n      ...TravellerClickActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...EGDSIconFragment\n      ... on Mark {\n        url {\n          ... on HttpURI {\n            value\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    accessibility\n    text\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    accessibility\n    decorative\n    size\n    text\n    theme\n    weight\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment FooterFragment on ReviewFooter {\n    primary {\n      ...EGDSStylizedTextFragment\n    }\n    text\n  }\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment ReviewSummaryFragment on ReviewSummary {\n    footer {\n      ...FooterFragment\n    }\n    highlightedText {\n      ...EGDSSpannableTextFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackCallToActionElementFragment on DirectFeedbackCallToActionElement {\n    ...EGDSInlineLinkFragment\n  }\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackPostSubmitElementFragment on DirectFeedbackPostSubmitElement {\n    ...EGDSSpannableTextFragment\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackCallToActionFragment on DirectFeedbackCallToAction {\n    callToAction {\n      ...DirectFeedbackCallToActionElementFragment\n    }\n    contextValues {\n      key\n      value\n    }\n    postSubmitDisplay {\n      ...DirectFeedbackPostSubmitElementFragment\n    }\n    promptId\n  }\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchFeedbackActionsFragment on TravellerSearchFeedbackAction {\n    clickAction {\n      ...TravellerClickActionFragment\n    }\n    directFeedbackCallToAction {\n      ...DirectFeedbackCallToActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchFeedbackFragment on TravellerSearchFeedback {\n    title\n    travellerSearchFeedbackActions {\n      ...TravellerSearchFeedbackActionsFragment\n    }\n  }\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  mutation ContentDirectFeedbackSubmitMutation($context: ContextInput!, $id: ID!, $feedback: DirectFeedbackValuesInput!) {\n    directFeedbackSubmit(context: $context, id: $id, feedback: $feedback) {\n      errors {\n        fieldId\n        error\n      }\n    }\n  }\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchSummaryFragment on TravellerSearchSummary {\n    heading\n    description {\n      graphic {\n        ...EGDSIconFragment\n      }\n      text\n    }\n    highlightedText {\n      ...EGDSSpannableTextFragment\n    }\n    travellerSearchFeedback {\n      ...TravellerSearchFeedbackFragment\n    }\n    itemSummary {\n      impressionAnalytics {\n        clickAnalytics {\n          eventType\n          linkName\n          referrerId\n        }\n      }\n      itemHeader\n      items {\n        ...ReviewSummaryFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchResultsResponseFragment on TravellerSearchResultsResponse {\n    noResultsMessage\n    accessibility\n    content {\n      ...TravellerSearchSummaryFragment\n    }\n    review {\n      ...TravellerSearchSummaryFragment\n    }\n    callToAction {\n      ...TravellerSearchDialogCTAFragment\n    }\n    disclaimerText\n  }\n  ", "\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  query TravellerSearchQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!, $searchTerm: String) {\n    travellerSearch(context: $context, searchTerm: $searchTerm, productIdentifier: $productIdentifier) {\n      ...TravellerSearchResultsResponseFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment SearchButtonFragment on TravellerSearchButton {\n    button {\n      ...EGDSButtonFragment\n    }\n    searchAction {\n      ...TravellerClickActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment EGDSInputFieldFragment on EGDSInputField {\n    instructions\n    label\n    placeholder\n    readOnly\n    required\n    value\n    leftIcon {\n      token\n    }\n  }\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextInputFieldFragment on EGDSTextInputField {\n    disabled\n    egdsElementId\n    ...EGDSInputFieldFragment\n  }\n\n  ", "\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment SearchInputFieldFragment on TravellerSearchInputField {\n    textInput {\n      ...EGDSTextInputFieldFragment\n    }\n    inputAction {\n      ...TravellerClickActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchInputFragment on TravellerSearchInput {\n    searchButton {\n      ...SearchButtonFragment\n    }\n    searchInputField {\n      ...SearchInputFieldFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchContentDialogFragment on TravellerSearchDialog {\n    dialogToolbar {\n      ...DialogToolbarFragment\n    }\n    travellerSearchInput {\n      ...TravellerSearchInputFragment\n    }\n    closeAction {\n      ...TravellerClickActionFragment\n    }\n    errorMessage {\n      ...ErrorMessageFragment\n    }\n    impressionAnalytics {\n      clickEvent {\n        eventName\n        eventType\n        eventVersion\n        eventCategory\n        actionLocation\n      }\n    }\n    loadingStateAccessibility\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment TravellerSearchContentFragment on TravellerSearch {\n    heading\n    paragraph\n    travellerSearchInput {\n      ...TravellerSearchInputFragment\n    }\n    travellerSearchDialog {\n      ...TravellerSearchContentDialogFragment\n    }\n    impressionAnalytics {\n      ...TravellerClickActionFragment\n    }\n    badge {\n      ...EGDSStandardBadgeFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  query AnsweringTravellerQuestionsContentSearchQuery($context: ContextInput!) {\n    answeringTravellerQuestions(context: $context) {\n      ...TravellerSearchContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
import React33, { useCallback as useCallback11 } from "react";
import { gql as gql33, useQuery } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker3 } from "@shared-ui/clickstream-analytics-context";
// src/utils/clickstream-event-builder.ts
var clickstreamEventBuilder = function (clickstreamEventData) {
  return {
    event: {
      event_name: clickstreamEventData.eventName,
      event_type: clickstreamEventData.eventType,
      event_version: clickstreamEventData.eventVersion,
      action_location: clickstreamEventData.actionLocation
    }
  };
};
// src/utils/defaults.ts
var CONTEXT_FEEDBACK_PROPERTY_SUMMARY_KEY = "feedback_property_summary";
var CONTEXT_FEEDBACK_REVIEW_SUMMARY_KEY = "feedback_review_summary";
var SCROLL_TIMEOUT = 1e3;
var TRAVELLER_SEARCH_DIALOG_ID = "traveller-search-content-dialog";
// src/components/inputs-context.tsx
import React from "react";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
  return IdentifierType2;
}(IdentifierType || {});
// src/components/inputs-context.tsx
var TravellerSearchInputsContext = React.createContext({
  inputs: {
    productIdentifier: {
      id: "",
      type: "ACTIVITY_ID" /* ACTIVITY_ID */
    }
  },
  dialogKey: "pwaDialog",
  dialogId: TRAVELLER_SEARCH_DIALOG_ID
});
var useTravellerSearchInputs = function () {
  return React.useContext(TravellerSearchInputsContext);
};
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-content.tsx
import React31, { useCallback as useCallback10, useMemo as useMemo5, useRef, useState as useState5 } from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSBadgeSize as EGDSBadgeSize2, EGDSBadgeStandard, EGDSBadgeStandardThemes as EGDSBadgeStandardThemes2 } from "@egds/react-core/badge";
import { EGDSIconSize } from "@egds/react-core/icons";
// ../internal/src/components/egds-badge/__private/mapper.ts
import { EGDSBadgeSize, EGDSBadgeStandardThemes } from "@egds/react-core/badge";
var _obj;
var BadgeThemeMap = Object.freeze((_obj = {}, _define_property(_obj, EGDSBadgeStandardThemes.STANDARD, "standard"), _define_property(_obj, EGDSBadgeStandardThemes.POSITIVE, "positive"), _define_property(_obj, EGDSBadgeStandardThemes.EMPHASIS, "emphasis"), _define_property(_obj, EGDSBadgeStandardThemes.INFO, "info"), _define_property(_obj, EGDSBadgeStandardThemes.FEATURED, "featured"), _define_property(_obj, EGDSBadgeStandardThemes.BRAND, "brand"), _define_property(_obj, EGDSBadgeStandardThemes.WARNING, "warning"), _obj));
var _obj1;
var BadgeSizeMap = Object.freeze((_obj1 = {}, _define_property(_obj1, EGDSBadgeSize.SMALL, "small"), _define_property(_obj1, EGDSBadgeSize.LARGE, "large"), _obj1));
// ../internal/src/components/egds-icon/egds-icon.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
var _obj2;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj2 = {}, _define_property(_obj2, "INFO" /* INFO */, "info"), _define_property(_obj2, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj2, "WARNING" /* WARNING */, "warning"), _define_property(_obj2, "STANDARD" /* STANDARD */, "standard"), _obj2);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment = gql(_templateObject());
var EGDSIcon = function (param) {
  var className = param.className,
    defaultIconSize = param.defaultIconSize,
    data = param.data,
    spotlight = param.spotlight;
  var id = data.id,
    token = data.token;
  if (!id || !token) {
    return null;
  }
  var description = data.description,
    withBackground = data.withBackground,
    size = data.size,
    spotLightData = data.spotLight,
    title = data.title,
    theme = data.theme;
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    className: className,
    description: description,
    id: id,
    name: token,
    shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
    size: size ? UitkIconSize[size] : defaultIconSize,
    spotlight: spotLightData ? spotlightMapper[spotLightData] : spotlight,
    title: title !== null && title !== void 0 ? title : void 0,
    theme: theme !== null && theme !== void 0 ? theme : void 0
  });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "UitkIcon";
// ../internal/src/components/egds-badge/egds-standard-badge.tsx
var fragment2 = gql2(_templateObject1(), EGDSIcon.fragment);
var EGDSStandardBadge = function (_param) {
  var data = _param.data,
    _param_theme = _param.theme,
    theme = _param_theme === void 0 ? EGDSBadgeStandardThemes2.STANDARD : _param_theme,
    _param_size = _param.size,
    size = _param_size === void 0 ? EGDSBadgeSize2.SMALL : _param_size,
    props = _object_without_properties(_param, ["data", "theme", "size"]);
  var text = data.text,
    graphic = data.graphic;
  if (!text) {
    return null;
  }
  var badgeProps = _object_spread({
    theme: (data === null || data === void 0 ? void 0 : data.theme) ? BadgeThemeMap[data.theme] : theme,
    size: (data === null || data === void 0 ? void 0 : data.size) ? BadgeSizeMap[data.size] : size
  }, props);
  return /* @__PURE__ */React3.createElement(EGDSBadgeStandard, _object_spread({
    text: text
  }, badgeProps), graphic && (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" ? /* @__PURE__ */React3.createElement(EGDSIcon, {
    data: graphic,
    defaultIconSize: EGDSIconSize.SMALL
  }) : null);
};
EGDSStandardBadge.fragment = fragment2;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-content.tsx
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkParagraph as UitkParagraph3 } from "uitk-react-text";
// src/components/answering-traveller-questions/common/traveller-click-action.ts
import { gql as gql3 } from "@apollo/client";
var __TravellerClickActionFragment = gql3(_templateObject2());
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-content-dialog.tsx
import React30, { useCallback as useCallback9, useEffect as useEffect4, useMemo as useMemo4, useState as useState4 } from "react";
import { gql as gql31 } from "@apollo/client";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker2, useClickTracker as useClickTracker5, useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { defaultViewSizes, useMediaQueries, ViewSizes } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
// src/components/answering-traveller-questions/__private/__fragments/dialog-toolbar.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkToolbar } from "uitk-react-toolbar";
var fragment3 = gql4(_templateObject3());
var DialogToolbar = function (param) {
  var data = param.data,
    closeDialog = param.closeDialog;
  var title = data.title,
    closeText = data.closeText;
  return /* @__PURE__ */React4.createElement(UitkToolbar, {
    navigationContent: {
      onClick: function (event) {
        closeDialog(event);
      },
      navIconLabel: closeText !== null && closeText !== void 0 ? closeText : "",
      navButtonId: "traveller-search-dialog-close"
    },
    toolbarTitle: title,
    toolbarTitleTag: "h2"
  });
};
DialogToolbar.fragment = fragment3;
DialogToolbar.displayName = "DialogToolbar";
// src/components/answering-traveller-questions/__private/__fragments/error-message.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkBanner } from "uitk-react-banner";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkHeading, UitkText } from "uitk-react-text";
var fragment4 = gql5(_templateObject4(), EGDSIcon.fragment);
var ErrorIcon = function (param) {
  var data = param.data;
  var _body_graphic;
  var body = data.body;
  if ((body === null || body === void 0 ? void 0 : body.__typename) !== "EGDSGraphicText" || (body === null || body === void 0 ? void 0 : (_body_graphic = body.graphic) === null || _body_graphic === void 0 ? void 0 : _body_graphic.__typename) !== "Icon") {
    return null;
  }
  return /* @__PURE__ */React5.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React5.createElement(EGDSIcon, {
    data: body === null || body === void 0 ? void 0 : body.graphic,
    spotlight: {
      theme: "standard",
      background: false
    }
  }));
};
var ErrorText = function (param) {
  var data = param.data;
  var body = data.body;
  if ((body === null || body === void 0 ? void 0 : body.__typename) !== "EGDSGraphicText" || !(body === null || body === void 0 ? void 0 : body.text)) {
    return null;
  }
  return /* @__PURE__ */React5.createElement(UitkText, null, body === null || body === void 0 ? void 0 : body.text);
};
var ErrorMessage = function (param) {
  var data = param.data;
  if (!(data === null || data === void 0 ? void 0 : data.heading) && !(data === null || data === void 0 ? void 0 : data.body)) {
    return null;
  }
  var heading = data.heading;
  return /* @__PURE__ */React5.createElement(UitkBanner, {
    theme: "error"
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlex, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React5.createElement(ErrorIcon, {
    data: data
  }), /* @__PURE__ */React5.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React5.createElement("div", {
    "aria-live": "polite"
  }, /* @__PURE__ */React5.createElement(UitkHeading, {
    size: 7,
    tag: "h3"
  }, heading), /* @__PURE__ */React5.createElement(ErrorText, {
    data: data
  })))));
};
ErrorMessage.fragment = fragment4;
ErrorMessage.displayName = "ErrorMessage";
// src/components/traveller-search/traveller-search.tsx
import React25, { useCallback as useCallback6, useEffect as useEffect2 } from "react";
import { gql as gql25, useLazyQuery } from "@apollo/client";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/common/loading-placeholder.tsx
import React6 from "react";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
import { UitkSpacing } from "uitk-react-spacing";
var LoadingPlaceholder = function (param) {
  var accessibility = param.accessibility;
  return /* @__PURE__ */React6.createElement(UitkLayoutFlex2, {
    blockSize: "full_size",
    direction: "column"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React6.createElement(UitkSpacing, {
    margin: {
      blockstart: "twelve",
      blockend: "six"
    }
  }, /* @__PURE__ */React6.createElement("div", {
    "aria-live": "polite"
  }, /* @__PURE__ */React6.createElement(UitkLoader, null), accessibility && /* @__PURE__ */React6.createElement("span", {
    className: "is-visually-hidden",
    "aria-live": "polite"
  }, accessibility)))));
};
LoadingPlaceholder.displayName = "LoadingPlaceholder";
// src/components/traveller-search/__private/__fragments/traveller-search-results-response.tsx
import React24 from "react";
import { gql as gql24 } from "@apollo/client";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkSpacing as UitkSpacing6, UitkSpacingHr } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph2, UitkText as UitkText7 } from "uitk-react-text";
// src/components/traveller-search/__private/__fragments/traveller-search-dialog-cta.tsx
import React8, { useCallback } from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkButtonSize } from "@egds/react-core/button";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing2 } from "@egds/react-core/spacing";
import { EgClickstreamImpressionTracker, IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useRefTargetScroll } from "@shared-ui/ref-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton } from "@egds/react-core/button";
// ../internal/src/components/utils/client-side-analytics.ts
import { gql as gql6 } from "@apollo/client";
var __ClientSideAnalyticsFragment = gql6(_templateObject5());
// ../internal/src/components/egds-button/egds-button.tsx
var fragment5 = gql7(_templateObject6(), EGDSIcon.fragment, __ClientSideAnalyticsFragment);
var EGDSButton = React7.forwardRef(function (props, ref) {
  var data = props.data;
  var disabled = props.disabled,
    onClickHandler = props.onClickHandler,
    isFullWidth = props.isFullWidth,
    size = props.size,
    className = props.className,
    type = props.type;
  var __typename = data.__typename,
    accessibility = data.accessibility,
    icon = data.icon,
    primary = data.primary;
  var buttonProps = {
    disabled: disabled,
    onClick: onClickHandler,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    isFullWidth: isFullWidth,
    size: size,
    className: className,
    type: type !== null && type !== void 0 ? type : "button",
    domRef: ref !== null && ref !== void 0 ? ref : null
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React7.createElement(UitkPrimaryButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */React7.createElement(EGDSIcon, {
        data: icon
      }), primary || null);
    case "UISecondaryButton":
      return /* @__PURE__ */React7.createElement(UitkSecondaryButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */React7.createElement(EGDSIcon, {
        data: icon
      }), primary || null);
    default:
      return null;
  }
});
EGDSButton.fragment = fragment5;
EGDSButton.displayName = "EGDSButton";
// src/components/traveller-search/__private/__fragments/traveller-search-dialog-cta.tsx
var fragment6 = gql8(_templateObject7(), EGDSButton.fragment, __TravellerClickActionFragment);
var TravellerSearchDialogCTA = function (param) {
  var data = param.data;
  var button = data.button,
    targetRef = data.targetRef;
  var scrollTo = useRefTargetScroll().scrollTo;
  var _useTravellerSearchInputs = useTravellerSearchInputs(),
    dialogId = _useTravellerSearchInputs.dialogId,
    dialogKey = _useTravellerSearchInputs.dialogKey;
  var trackUisPrime = useClickTracker();
  var _useDialog = _sliced_to_array(useDialog(dialogId, dialogKey), 2),
    dialogActions = _useDialog[1];
  var handleClickTracking = useCallback(function () {
    if (button === null || button === void 0 ? void 0 : button.analytics) {
      var analytics = button.analytics;
      trackUisPrime(analytics.referrerId, analytics.linkName, false);
    }
  }, [button, trackUisPrime]);
  var onCTAClickHandler = useCallback(function () {
    handleClickTracking();
    dialogActions === null || dialogActions === void 0 ? void 0 : dialogActions.closeDialog();
    if (targetRef) {
      setTimeout(function () {
        scrollTo(targetRef, []);
      }, SCROLL_TIMEOUT);
    }
  }, [targetRef, scrollTo, handleClickTracking, dialogActions]);
  var impressionAnalyticsEgClickstreamDataFormatter = function (analyticsData) {
    if (!analyticsData) {
      return {};
    }
    var eventName = analyticsData.eventName,
      eventType = analyticsData.eventType,
      eventVersion = analyticsData.eventVersion,
      actionLocation = analyticsData.actionLocation;
    var clickstreamEventData = {
      eventName: eventName,
      eventVersion: eventVersion,
      eventType: eventType,
      actionLocation: actionLocation || ""
    };
    var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
    return clickstreamEvent;
  };
  if (!button) {
    return null;
  }
  var impressionAnalytics = data.impressionAnalytics;
  var dialogCTA = /* @__PURE__ */React8.createElement(UitkSpacing2, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React8.createElement(UitkLayoutFlex3, {
    direction: "column"
  }, /* @__PURE__ */React8.createElement(UitkLayoutFlexItem3, {
    alignSelf: "center"
  }, /* @__PURE__ */React8.createElement(EGDSButton, {
    size: UitkButtonSize.MEDIUM,
    isFullWidth: false,
    data: button,
    onClickHandler: onCTAClickHandler
  }), ";")));
  if (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.clickAnalytics) {
    var clickAnalytics = impressionAnalytics.clickAnalytics;
    return /* @__PURE__ */React8.createElement(IntersectionTracker, {
      referrerId: clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId,
      linkName: clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName
    }, dialogCTA);
  }
  if (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.clickEvent) {
    return /* @__PURE__ */React8.createElement(EgClickstreamImpressionTracker, {
      eventData: impressionAnalyticsEgClickstreamDataFormatter(impressionAnalytics.clickEvent)
    }, dialogCTA);
  }
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, dialogCTA);
};
TravellerSearchDialogCTA.fragment = fragment6;
TravellerSearchDialogCTA.displayName = "TravellerSearchDialogCTA";
// src/components/traveller-search/__private/__fragments/traveller-search-summary.tsx
import React23, { useCallback as useCallback5, useMemo as useMemo3 } from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2, EGDSSpacingHr } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { SearchHighlight as SearchHighlight2 } from "@egds/react-property-experience";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSMark, UitkMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment7 = gql9(_templateObject8(), EGDSIcon.fragment);
var EGDSGraphicText = function (param) {
  var data = param.data,
    textProps = param.textProps,
    _param_size = param.size,
    size = _param_size === void 0 ? 200 : _param_size;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    graphic = data.graphic;
  var graphicElement = function () {
    if (graphic.__typename === "Icon") {
      return /* @__PURE__ */React9.createElement(EGDSIcon, {
        data: graphic
      });
    }
    if (graphic.__typename === "Mark") {
      var _graphic_url;
      return /* @__PURE__ */React9.createElement(EGDSSpacing, {
        padding: {
          inlineend: "two"
        }
      }, /* @__PURE__ */React9.createElement(EGDSMark, {
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        size: UitkMarkSize.SMALL
      }));
    }
  };
  return /* @__PURE__ */React9.createElement(UitkText2, _object_spread({
    size: size
  }, textProps), graphicElement(), text);
};
EGDSGraphicText.fragment = fragment7;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-heading/egds-heading.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSHeading as EGDSReactCoreHeading } from "@egds/react-core/text";
var fragment8 = gql10(_templateObject9());
var EGDSHeading = function (props) {
  var data = props.data,
    className = props.className,
    size = props.size,
    align = props.align,
    tag = props.tag;
  var accessibility = data.accessibility,
    text = data.text;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React10.createElement(EGDSReactCoreHeading, {
    className: className,
    size: size,
    align: align,
    tag: tag,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0
  }, text);
};
EGDSHeading.fragment = fragment8;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var _obj3;
// ../internal/src/components/egds-stylized-text/__private/mapper.ts
var UitkThemeMap = Object.freeze((_obj3 = {}, _define_property(_obj3, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj3, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj3, "default", "default"), _obj3));
var _obj4;
var UitkWeightMap = Object.freeze((_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */, "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */, "regular"), _obj4));
var UitkSizeMap = Object.freeze({
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
});
var DecorativeMap = Object.freeze({
  HIGHLIGHT: "mark",
  LINE_THROUGH: "s",
  SUBSCRIPT: "sub",
  SUPERSCRIPT: "sup",
  UNDERLINE: "u"
});
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
var fragment9 = gql11(_templateObject10());
var EGDSStylizedText = function (_param) {
  var data = _param.data,
    _param_theme = _param.theme,
    theme = _param_theme === void 0 ? "default" : _param_theme,
    _param_weight = _param.weight,
    weight = _param_weight === void 0 ? "regular" : _param_weight,
    _param_size = _param.size,
    size = _param_size === void 0 ? 300 : _param_size,
    props = _object_without_properties(_param, ["data", "theme", "weight", "size"]);
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    decorative = data.decorative,
    accessibility = data.accessibility;
  var textProps = _object_spread({
    theme: (data === null || data === void 0 ? void 0 : data.theme) ? UitkThemeMap[data.theme] : theme,
    weight: (data === null || data === void 0 ? void 0 : data.weight) ? UitkWeightMap[data.weight] : weight,
    size: (data === null || data === void 0 ? void 0 : data.size) ? UitkSizeMap[data.size] : size
  }, props);
  var Decorative = decorative && DecorativeMap[decorative];
  var content = Decorative ? /* @__PURE__ */React11.createElement(Decorative, null, text) : text;
  return /* @__PURE__ */React11.createElement(React11.Fragment, null, /* @__PURE__ */React11.createElement(EGDSText, _object_spread({
    "aria-hidden": Boolean(accessibility)
  }, textProps), content), accessibility && /* @__PURE__ */React11.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSStylizedText.fragment = fragment9;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment10 = gql12(_templateObject11());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    size = param.size,
    align = param.align,
    data = param.data,
    spacing = param.spacing;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    accessibility = data.accessibility;
  return /* @__PURE__ */React12.createElement(UitkText3, {
    className: className,
    inline: inline,
    size: size,
    align: align,
    spacing: spacing
  }, text, accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSPlainText.fragment = fragment10;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
var fragment11 = gql13(_templateObject12(), EGDSHeading.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    headingProps = param.headingProps,
    data = param.data,
    inline = param.inline;
  switch (data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React13.createElement(EGDSHeading, _object_spread({
        data: data
      }, headingProps));
    case "EGDSStylizedText":
      return /* @__PURE__ */React13.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React13.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React13.createElement(EGDSGraphicText, {
        data: data,
        size: size
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment11;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment12 = gql14(_templateObject13(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_inlineContent;
  var align = props.align,
    data = props.data,
    styleProps = _object_without_properties(props, ["align", "data"]);
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
    return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React14.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index)
      }));
    }));
  }
  if (data === null || data === void 0 ? void 0 : data.text) {
    return /* @__PURE__ */React14.createElement(UitkText4, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align
    }), data.text);
  }
  return null;
};
EGDSSpannableText.fragment = fragment12;
EGDSSpannableText.displayName = "EGDSSpannableText";
// src/components/traveller-search/__private/__fragments/review-summary.tsx
import React16, { useCallback as useCallback2, useMemo } from "react";
import { gql as gql16 } from "@apollo/client";
import { SearchHighlight } from "@egds/react-property-experience";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkParagraph } from "uitk-react-text";
// src/components/traveller-search/__private/__fragments/footer.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
var fragment13 = gql15(_templateObject14(), EGDSStylizedText.fragment);
var Footer = function (param) {
  var data = param.data;
  var primary = data.primary,
    text = data.text;
  if (!primary && !text) {
    return null;
  }
  var inlinestartPadding = {
    inlinestart: "two"
  };
  return /* @__PURE__ */React15.createElement(UitkSpacing3, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React15.createElement(UitkText5, null, primary && /* @__PURE__ */React15.createElement(EGDSStylizedText, {
    data: primary,
    inline: true,
    size: 200,
    weight: "medium"
  }), text && /* @__PURE__ */React15.createElement(UitkSpacing3, {
    padding: primary ? inlinestartPadding : void 0
  }, /* @__PURE__ */React15.createElement(UitkText5, {
    inline: true,
    size: 200,
    weight: "regular"
  }, text))));
};
Footer.fragment = fragment13;
Footer.displayName = "Footer";
// src/components/traveller-search/__private/__fragments/review-summary.tsx
var fragment14 = gql16(_templateObject15(), Footer.fragment, EGDSSpannableText.fragment);
var ReviewSummary = function (param) {
  var data = param.data;
  var getReviewSummary = useCallback2(function (highlightedReviewText) {
    var _highlightedReviewText_inlineContent;
    if (!highlightedReviewText) {
      return null;
    }
    if (highlightedReviewText === null || highlightedReviewText === void 0 ? void 0 : (_highlightedReviewText_inlineContent = highlightedReviewText.inlineContent) === null || _highlightedReviewText_inlineContent === void 0 ? void 0 : _highlightedReviewText_inlineContent.length) {
      return /* @__PURE__ */React16.createElement(SearchHighlight, {
        size: 400,
        inlineContentList: highlightedReviewText.inlineContent
      });
    }
    return highlightedReviewText === null || highlightedReviewText === void 0 ? void 0 : highlightedReviewText.text;
  }, []);
  var reviewSummaryText = useMemo(function () {
    return getReviewSummary(data === null || data === void 0 ? void 0 : data.highlightedText);
  }, [data, getReviewSummary]);
  if (!(data === null || data === void 0 ? void 0 : data.footer) && !(data === null || data === void 0 ? void 0 : data.highlightedText)) {
    return null;
  }
  var footer = data.footer,
    highlightedText = data.highlightedText;
  return /* @__PURE__ */React16.createElement(UitkSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React16.createElement("div", null, highlightedText && /* @__PURE__ */React16.createElement(UitkParagraph, {
    size: 1
  }, reviewSummaryText), footer && /* @__PURE__ */React16.createElement(Footer, {
    data: footer
  })));
};
ReviewSummary.fragment = fragment14;
ReviewSummary.displayName = "ReviewSummary";
// src/components/traveller-search/__private/__fragments/traveller-search-feedback.tsx
import React22, { useCallback as useCallback4, useState as useState2 } from "react";
import { gql as gql22, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
// src/components/traveller-search/__private/__fragments/traveller-search-feedback-actions.tsx
import React21, { useCallback as useCallback3, useEffect, useState } from "react";
import { gql as gql21 } from "@apollo/client";
import { useClickTracker as useClickTracker2, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
// src/components/traveller-search/__private/__fragments/direct-feedback-call-to-action.tsx
import React20 from "react";
import { gql as gql20 } from "@apollo/client";
// src/components/traveller-search/__private/__fragments/direct-feedback-call-to-action-element.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
// ../internal/src/components/egds-link/egds-inline-link.tsx
import React17, { useMemo as useMemo2 } from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkLink } from "uitk-react-link";
var _obj5;
// ../internal/src/components/utils/uitk-link-utils.ts
var linkSizeMapper = (_obj5 = {}, _define_property(_obj5, "SMALL" /* SMALL */, "small"), _define_property(_obj5, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj5, "LARGE" /* LARGE */, "large"), _obj5);
var _obj6;
var UILinkTargetMap = (_obj6 = {}, _define_property(_obj6, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj6, "INTERNAL" /* INTERNAL */, "_self"), _obj6);
// ../internal/src/components/egds-link/egds-inline-link.tsx
var fragment15 = gql17(_templateObject16());
var EGDSInlineLink = function (param) {
  var className = param.className,
    data = param.data,
    _param_size = param.size,
    size = _param_size === void 0 ? "medium" : _param_size,
    _param_inline = param.inline,
    inline = _param_inline === void 0 ? true : _param_inline,
    onLinkClick = param.onLinkClick,
    _param_type = param.type,
    type = _param_type === void 0 ? "link" /* LINK */ : _param_type;
  var child = useMemo2(function () {
    if (!data) {
      return null;
    }
    var text = data.text,
      action = data.action;
    return /* @__PURE__ */React17.createElement(React17.Fragment, null, text, (action === null || action === void 0 ? void 0 : action.accessibility) && /* @__PURE__ */React17.createElement("span", {
      className: "is-visually-hidden"
    }, action.accessibility));
  }, [data]);
  var wrappedChildren = useMemo2(function () {
    if (!data) {
      return null;
    }
    var action = data.action;
    switch (type) {
      case "button" /* BUTTON */:
        return /* @__PURE__ */React17.createElement("button", {
          type: "button"
        }, child);
      case "link" /* LINK */:
      default:
        var _action_resource;
        return /* @__PURE__ */React17.createElement("a", {
          href: action === null || action === void 0 ? void 0 : (_action_resource = action.resource) === null || _action_resource === void 0 ? void 0 : _action_resource.value,
          target: (action === null || action === void 0 ? void 0 : action.target) ? UILinkTargetMap[action.target] : void 0
        }, child);
    }
  }, [data, child, type]);
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var disabled = data.disabled,
    linkSize = data.linkSize;
  return /* @__PURE__ */React17.createElement(UitkLink, {
    className: className,
    size: linkSize ? linkSizeMapper[linkSize] : size,
    onClickCapture: onLinkClick,
    disabled: disabled,
    inline: inline
  }, wrappedChildren);
};
EGDSInlineLink.fragment = fragment15;
EGDSInlineLink.displayName = "EGDSInlineLink";
// src/components/traveller-search/__private/__fragments/direct-feedback-call-to-action-element.tsx
var fragment16 = gql18(_templateObject17(), EGDSInlineLink.fragment);
var DirectFeedbackCallToActionElement = function (param) {
  var data = param.data,
    handleClick = param.handleClick;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "EGDSInlineLink":
      return /* @__PURE__ */React18.createElement(EGDSInlineLink, {
        data: data,
        size: "medium",
        inline: false,
        onLinkClick: handleClick,
        type: "button" /* BUTTON */
      });
    default:
      return null;
  }
};
DirectFeedbackCallToActionElement.fragment = fragment16;
DirectFeedbackCallToActionElement.displayName = "DirectFeedbackCallToActionElement";
// src/components/traveller-search/__private/__fragments/direct-feedback-post-submit-element.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
var fragment17 = gql19(_templateObject18(), EGDSSpannableText.fragment);
var DirectFeedbackPostSubmitElement = function (param) {
  var data = param.data;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "EGDSSpannableText":
      return /* @__PURE__ */React19.createElement(EGDSSpannableText, {
        data: data,
        inline: true
      });
    default:
      return null;
  }
};
DirectFeedbackPostSubmitElement.fragment = fragment17;
DirectFeedbackPostSubmitElement.displayName = "DirectFeedbackPostSubmitElement";
// src/components/traveller-search/__private/__fragments/direct-feedback-call-to-action.tsx
var fragment18 = gql20(_templateObject19(), DirectFeedbackCallToActionElement.fragment, DirectFeedbackPostSubmitElement.fragment);
var DirectFeedbackCallToAction = function (param) {
  var _param_directFeedbackCallToActionElement = param.directFeedbackCallToActionElement,
    directFeedbackCallToActionElement = _param_directFeedbackCallToActionElement === void 0 ? null : _param_directFeedbackCallToActionElement,
    _param_postSubmitDisplayElement = param.postSubmitDisplayElement,
    postSubmitDisplayElement = _param_postSubmitDisplayElement === void 0 ? null : _param_postSubmitDisplayElement;
  return /* @__PURE__ */React20.createElement(React20.Fragment, null, directFeedbackCallToActionElement, postSubmitDisplayElement);
};
DirectFeedbackCallToAction.fragment = fragment18;
DirectFeedbackCallToAction.displayName = "DirectFeedbackCallToAction";
// src/components/traveller-search/__private/__fragments/traveller-search-feedback-actions.tsx
var fragment19 = gql21(_templateObject20(), DirectFeedbackCallToAction.fragment, __TravellerClickActionFragment);
var TravellerSearchFeedbackActions = function (param) {
  var data = param.data,
    selectedFeedbackValue = param.selectedFeedbackValue,
    handleCallToActionElementClick = param.handleCallToActionElementClick;
  var _useState = _sliced_to_array(useState(false), 2),
    showPostSubmitDisplay = _useState[0],
    setShowPostSubmitDisplay = _useState[1];
  var directFeedbackCallToAction = data.directFeedbackCallToAction,
    clickAction = data.clickAction;
  var track = useEgClickstream();
  var trackUisPrime = useClickTracker2();
  var handleTrackRequest = useCallback3(function (clickstreamData) {
    if (!clickstreamData) {
      return null;
    }
    var eventName = clickstreamData.eventName,
      eventType = clickstreamData.eventType,
      eventVersion = clickstreamData.eventVersion,
      actionLocation = clickstreamData.actionLocation;
    var clickstreamEventData = {
      eventName: eventName,
      eventVersion: eventVersion,
      eventType: eventType,
      actionLocation: actionLocation || ""
    };
    var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
    track(clickstreamEvent);
  }, [track]);
  var handleTrackRequestWithUisPrime = useCallback3(function (clickAnalytics) {
    trackUisPrime(clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId, clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName, false);
  }, [trackUisPrime]);
  var handleActionElementClick = useCallback3(function (event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    if (handleCallToActionElementClick) {
      handleCallToActionElementClick(directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : directFeedbackCallToAction.contextValues, directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : directFeedbackCallToAction.promptId);
    }
    if (clickAction === null || clickAction === void 0 ? void 0 : clickAction.clickAnalytics) {
      handleTrackRequestWithUisPrime(clickAction.clickAnalytics);
    } else if (clickAction === null || clickAction === void 0 ? void 0 : clickAction.clickEvent) {
      handleTrackRequest(clickAction.clickEvent);
    }
  }, [directFeedbackCallToAction, handleCallToActionElementClick, clickAction, handleTrackRequest, handleTrackRequestWithUisPrime]);
  useEffect(function () {
    var _directFeedbackCallToAction_contextValues;
    if (selectedFeedbackValue && (directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : (_directFeedbackCallToAction_contextValues = directFeedbackCallToAction.contextValues) === null || _directFeedbackCallToAction_contextValues === void 0 ? void 0 : _directFeedbackCallToAction_contextValues.length)) {
      var contextValues = directFeedbackCallToAction.contextValues;
      var contextFeedback = contextValues === null || contextValues === void 0 ? void 0 : contextValues.find(function (eachValue) {
        return eachValue.key === CONTEXT_FEEDBACK_PROPERTY_SUMMARY_KEY || eachValue.key === CONTEXT_FEEDBACK_REVIEW_SUMMARY_KEY;
      });
      if ((contextFeedback === null || contextFeedback === void 0 ? void 0 : contextFeedback.value) === selectedFeedbackValue) {
        setShowPostSubmitDisplay(true);
      }
    }
  }, [selectedFeedbackValue, directFeedbackCallToAction]);
  if (!(data === null || data === void 0 ? void 0 : data.directFeedbackCallToAction)) {
    return null;
  }
  var directFeedbackCallToActionElement = (directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : directFeedbackCallToAction.callToAction) && !selectedFeedbackValue ? /* @__PURE__ */React21.createElement(UitkLayoutFlexItem4, {
    shrink: 1,
    grow: 0
  }, /* @__PURE__ */React21.createElement("div", null, /* @__PURE__ */React21.createElement(DirectFeedbackCallToActionElement, {
    data: directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : directFeedbackCallToAction.callToAction,
    handleClick: handleActionElementClick
  }))) : null;
  var postSubmitDisplayElement = (directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : directFeedbackCallToAction.postSubmitDisplay) && showPostSubmitDisplay ? /* @__PURE__ */React21.createElement(UitkLayoutFlexItem4, {
    shrink: 1,
    grow: 0
  }, /* @__PURE__ */React21.createElement(DirectFeedbackPostSubmitElement, {
    data: directFeedbackCallToAction === null || directFeedbackCallToAction === void 0 ? void 0 : directFeedbackCallToAction.postSubmitDisplay
  })) : null;
  return /* @__PURE__ */React21.createElement(React21.Fragment, null, directFeedbackCallToAction && /* @__PURE__ */React21.createElement(DirectFeedbackCallToAction, {
    data: directFeedbackCallToAction,
    directFeedbackCallToActionElement: directFeedbackCallToActionElement,
    postSubmitDisplayElement: postSubmitDisplayElement
  }));
};
TravellerSearchFeedbackActions.fragment = fragment19;
TravellerSearchFeedbackActions.displayName = "TravellerSearchFeedbackActions";
// src/components/traveller-search/__private/__fragments/traveller-search-feedback.tsx
var fragment20 = gql22(_templateObject21(), TravellerSearchFeedbackActions.fragment);
var __Mutation = gql22(_templateObject22());
var TravellerSearchFeedback = function (param) {
  var data = param.data;
  var title = data.title,
    travellerSearchFeedbackActions = data.travellerSearchFeedbackActions;
  var _useState2 = _sliced_to_array(useState2(), 2),
    feedbackValue = _useState2[0],
    setFeedbackValue = _useState2[1];
  var _useMutation = _sliced_to_array(useMutation(__Mutation), 1),
    handleDirectFeedbackSubmit = _useMutation[0];
  var context = useBexApi().context;
  var getFeedbacks = function (feedbackContexts) {
    var updatedFeedbackContexts = feedbackContexts === null || feedbackContexts === void 0 ? void 0 : feedbackContexts.map(function (eachFeedback) {
      var updatedFeedback = _object_spread({}, eachFeedback);
      updatedFeedback === null || updatedFeedback === void 0 ? true : delete updatedFeedback.__typename;
      return updatedFeedback;
    });
    return {
      context: updatedFeedbackContexts,
      formValues: []
    };
  };
  var handleClick = useCallback4(function (contextKeyValuePairs, promptId) {
    var feedbackKeyValue = contextKeyValuePairs.find(function (eachContextKeyValuePair) {
      return eachContextKeyValuePair.key === CONTEXT_FEEDBACK_PROPERTY_SUMMARY_KEY || eachContextKeyValuePair.key === CONTEXT_FEEDBACK_REVIEW_SUMMARY_KEY;
    });
    if (feedbackKeyValue) {
      setFeedbackValue(feedbackKeyValue === null || feedbackKeyValue === void 0 ? void 0 : feedbackKeyValue.value);
    }
    var formattedFeedbackContexts = getFeedbacks(contextKeyValuePairs);
    handleDirectFeedbackSubmit({
      variables: {
        context: context,
        feedback: formattedFeedbackContexts,
        id: promptId
      }
    });
  }, [context, handleDirectFeedbackSubmit]);
  return /* @__PURE__ */React22.createElement(React22.Fragment, null, title && /* @__PURE__ */React22.createElement(UitkSpacing5, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React22.createElement(UitkLayoutFlex4, {
    space: "three"
  }, /* @__PURE__ */React22.createElement(UitkLayoutFlexItem5, {
    shrink: 0
  }, title && !feedbackValue && /* @__PURE__ */React22.createElement(UitkText6, {
    weight: "regular"
  }, title)), (travellerSearchFeedbackActions === null || travellerSearchFeedbackActions === void 0 ? void 0 : travellerSearchFeedbackActions.length) && travellerSearchFeedbackActions.map(function (eachTravellerSearchFeedbackActions, index) {
    return /* @__PURE__ */React22.createElement(TravellerSearchFeedbackActions, {
      key: "traveller-search-feedback-action-".concat(index),
      data: eachTravellerSearchFeedbackActions,
      handleCallToActionElementClick: handleClick,
      selectedFeedbackValue: feedbackValue
    });
  }))));
};
TravellerSearchFeedback.fragment = fragment20;
TravellerSearchFeedback.displayName = "TravellerSearchFeedback";
// src/components/traveller-search/__private/__fragments/traveller-search-summary.tsx
var fragment21 = gql23(_templateObject23(), EGDSSpannableText.fragment, TravellerSearchFeedback.fragment, ReviewSummary.fragment, EGDSIcon.fragment);
var TravellerSearchSummary = function (param) {
  var data = param.data;
  var _itemSummary_impressionAnalytics, _itemSummary_items, _itemSummary_items1;
  var highlightedText = data.highlightedText,
    travellerSearchFeedback = data.travellerSearchFeedback,
    heading = data.heading,
    description = data.description,
    itemSummary = data.itemSummary;
  var clickAnalytics = itemSummary === null || itemSummary === void 0 ? void 0 : (_itemSummary_impressionAnalytics = itemSummary.impressionAnalytics) === null || _itemSummary_impressionAnalytics === void 0 ? void 0 : _itemSummary_impressionAnalytics.clickAnalytics;
  var getTravellerSearchSummary = useCallback5(function (highlightedReviewText) {
    var _highlightedReviewText_inlineContent;
    if (!highlightedReviewText) {
      return null;
    }
    if (highlightedReviewText === null || highlightedReviewText === void 0 ? void 0 : (_highlightedReviewText_inlineContent = highlightedReviewText.inlineContent) === null || _highlightedReviewText_inlineContent === void 0 ? void 0 : _highlightedReviewText_inlineContent.length) {
      return /* @__PURE__ */React23.createElement(SearchHighlight2, {
        size: 400,
        inlineContentList: highlightedReviewText.inlineContent
      });
    }
    return highlightedReviewText === null || highlightedReviewText === void 0 ? void 0 : highlightedReviewText.text;
  }, []);
  var summaryText = useMemo3(function () {
    return getTravellerSearchSummary(highlightedText);
  }, [highlightedText, getTravellerSearchSummary]);
  var travellerSearchQueryContent = /* @__PURE__ */React23.createElement(React23.Fragment, null, heading && /* @__PURE__ */React23.createElement(EGDSSpacing2, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React23.createElement(EGDSHeading2, {
    tag: "h3",
    size: 6
  }, heading)), highlightedText && /* @__PURE__ */React23.createElement(EGDSCard, {
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React23.createElement(EGDSCardContentSection, {
    padded: true
  }, /* @__PURE__ */React23.createElement(EGDSText2, {
    spacing: "one"
  }, summaryText), description && /* @__PURE__ */React23.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "three",
      blockend: "one"
    }
  }, /* @__PURE__ */React23.createElement(EGDSLayoutFlex, {
    direction: "row"
  }, description.graphic.__typename === "Icon" && /* @__PURE__ */React23.createElement(EGDSSpacing2, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React23.createElement(EGDSIcon, {
    data: description.graphic,
    defaultIconSize: EGDSIconSize2.EXTRA_SMALL
  })), /* @__PURE__ */React23.createElement(EGDSText2, {
    size: 200
  }, description.text))))), travellerSearchFeedback && /* @__PURE__ */React23.createElement(TravellerSearchFeedback, {
    data: travellerSearchFeedback
  }), ((itemSummary === null || itemSummary === void 0 ? void 0 : itemSummary.itemHeader) || (itemSummary === null || itemSummary === void 0 ? void 0 : (_itemSummary_items = itemSummary.items) === null || _itemSummary_items === void 0 ? void 0 : _itemSummary_items.length)) && highlightedText ? /* @__PURE__ */React23.createElement(EGDSSpacingHr, null) : null, (itemSummary === null || itemSummary === void 0 ? void 0 : itemSummary.itemHeader) && /* @__PURE__ */React23.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React23.createElement(EGDSHeading2, {
    tag: "h4",
    size: 6
  }, itemSummary.itemHeader)), (itemSummary === null || itemSummary === void 0 ? void 0 : (_itemSummary_items1 = itemSummary.items) === null || _itemSummary_items1 === void 0 ? void 0 : _itemSummary_items1.length) ? /* @__PURE__ */React23.createElement("div", null, itemSummary.items.map(function (eachItem, index) {
    return /* @__PURE__ */React23.createElement(ReviewSummary, {
      data: eachItem,
      key: "review-".concat(index)
    });
  })) : null);
  return clickAnalytics ? /* @__PURE__ */React23.createElement(IntersectionTracker2, {
    referrerId: clickAnalytics.referrerId,
    linkName: clickAnalytics.linkName
  }, travellerSearchQueryContent) : travellerSearchQueryContent;
};
TravellerSearchSummary.fragment = fragment21;
TravellerSearchSummary.displayName = "TravellerSearchSummary";
// src/components/traveller-search/__private/__fragments/traveller-search-results-response.tsx
var fragment22 = gql24(_templateObject24(), TravellerSearchSummary.fragment, TravellerSearchDialogCTA.fragment);
var TravellerSearchResultsResponse = function (param) {
  var data = param.data;
  var content = data.content,
    review = data.review,
    noResultsMessage = data.noResultsMessage,
    disclaimerText = data.disclaimerText,
    accessibility = data.accessibility,
    callToAction = data.callToAction;
  return /* @__PURE__ */React24.createElement(UitkSpacing6, {
    margin: {
      blockstart: "four",
      blockend: "six"
    }
  }, /* @__PURE__ */React24.createElement("div", null, accessibility && /* @__PURE__ */React24.createElement("span", {
    className: "is-visually-hidden",
    "aria-live": "polite",
    role: "status"
  }, accessibility), content && !noResultsMessage && /* @__PURE__ */React24.createElement(TravellerSearchSummary, {
    data: content
  }), review && content && /* @__PURE__ */React24.createElement("div", null, /* @__PURE__ */React24.createElement(UitkSpacingHr, {
    blockMargin: "six"
  })), review && !noResultsMessage && /* @__PURE__ */React24.createElement(TravellerSearchSummary, {
    data: review
  }), noResultsMessage && /* @__PURE__ */React24.createElement(UitkParagraph2, {
    size: 1
  }, noResultsMessage), /* @__PURE__ */React24.createElement(Experiment, {
    name: "Apps_Traveller_QnA_Choose_a_room_CTA_in_modal"
  }, /* @__PURE__ */React24.createElement(ExperimentControl, null), /* @__PURE__ */React24.createElement(ExperimentVariant, {
    bucket: 1
  }, callToAction && /* @__PURE__ */React24.createElement(TravellerSearchDialogCTA, {
    data: callToAction
  }))), disclaimerText && /* @__PURE__ */React24.createElement(UitkSpacing6, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React24.createElement(UitkText7, {
    size: 100,
    weight: "regular",
    theme: "default"
  }, disclaimerText))));
};
TravellerSearchResultsResponse.fragment = fragment22;
TravellerSearchResultsResponse.displayName = "TravellerSearchResultsResponse";
// src/components/traveller-search/traveller-search.tsx
var __Query = gql25(_templateObject25(), TravellerSearchResultsResponse.fragment);
var TravellerSearch = function (props) {
  var searchTerm = props.searchTerm,
    inputs = props.inputs,
    onSearchError = props.onSearchError,
    loadingStateAccessibility = props.loadingStateAccessibility;
  var context = useBexApi2().context;
  var handleTravellerSearchQueryCompletion = useCallback6(function (data2) {
    if (data2 && (data2 === null || data2 === void 0 ? void 0 : data2.travellerSearch) === null) {
      onSearchError();
    }
  }, [onSearchError]);
  var _useLazyQuery = _sliced_to_array(useLazyQuery(__Query, {
      ssr: true,
      fetchPolicy: "no-cache",
      onCompleted: handleTravellerSearchQueryCompletion
    }), 2),
    initiateTravellerSearchQuery = _useLazyQuery[0],
    result = _useLazyQuery[1];
  var loading = result.loading,
    error = result.error,
    data = result.data;
  var handleTravellerSearchRequest = useCallback6(function () {
    if (searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim().length) {
      var variables = _object_spread_props(_object_spread({
        context: context
      }, inputs), {
        searchTerm: searchTerm
      });
      initiateTravellerSearchQuery({
        variables: variables
      });
    }
  }, [context, searchTerm, inputs, initiateTravellerSearchQuery]);
  var handleResultUpdateAnnouncement = useCallback6(function () {
    var _data_travellerSearch;
    if (data === null || data === void 0 ? void 0 : (_data_travellerSearch = data.travellerSearch) === null || _data_travellerSearch === void 0 ? void 0 : _data_travellerSearch.accessibility) {
      var _data_travellerSearch1;
      liveAnnounce(data === null || data === void 0 ? void 0 : (_data_travellerSearch1 = data.travellerSearch) === null || _data_travellerSearch1 === void 0 ? void 0 : _data_travellerSearch1.accessibility, Level.POLITE);
    }
  }, [data]);
  var handleLoadingAnnouncement = useCallback6(function () {
    if (loadingStateAccessibility) {
      liveAnnounce(loadingStateAccessibility, Level.POLITE);
    }
  }, [loadingStateAccessibility]);
  useEffect2(handleTravellerSearchRequest, [searchTerm, handleTravellerSearchRequest]);
  useEffect2(handleResultUpdateAnnouncement, [data, handleResultUpdateAnnouncement]);
  if (loading) {
    handleLoadingAnnouncement();
    return /* @__PURE__ */React25.createElement(LoadingPlaceholder, {
      accessibility: loadingStateAccessibility
    });
  }
  if (error) {
    onSearchError();
    return null;
  }
  if (!(data === null || data === void 0 ? void 0 : data.travellerSearch)) {
    return null;
  }
  var travellerSearch = data.travellerSearch;
  return /* @__PURE__ */React25.createElement(TravellerSearchResultsResponse, {
    data: travellerSearch
  });
};
TravellerSearch.displayName = "TravellerSearch";
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-input.tsx
import React29, { useCallback as useCallback8, useEffect as useEffect3, useState as useState3 } from "react";
import { gql as gql30 } from "@apollo/client";
import { useClickTracker as useClickTracker4, useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
// src/components/answering-traveller-questions-content-search/__private/__fragments/search-button.tsx
import React26 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize2 } from "@egds/react-core/button";
var fragment23 = gql26(_templateObject26(), EGDSButton.fragment, __TravellerClickActionFragment);
var SearchButton = React26.forwardRef(function (props, ref) {
  var button = props.data.button,
    isSubmitDisabled = props.isSubmitDisabled,
    handleOnClick = props.handleOnClick;
  return /* @__PURE__ */React26.createElement(React26.Fragment, null, button && /* @__PURE__ */React26.createElement(EGDSButton, {
    data: button,
    type: "submit",
    onClickHandler: handleOnClick,
    size: UitkButtonSize2.LARGE,
    ref: ref !== null && ref !== void 0 ? ref : null,
    disabled: isSubmitDisabled
  }));
});
SearchButton.fragment = fragment23;
SearchButton.displayName = "SearchButton";
// src/components/answering-traveller-questions-content-search/__private/__fragments/search-input-field.tsx
import React28, { useCallback as useCallback7 } from "react";
import { gql as gql29 } from "@apollo/client";
import { useClickTracker as useClickTracker3, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-text-input/egds-text-input-field.tsx
import React27 from "react";
import { gql as gql28 } from "@apollo/client";
import { UitkTextInput } from "uitk-react-input";
// ../internal/src/components/egds-text-input/egds-input-field.ts
import { gql as gql27 } from "@apollo/client";
var __EGDSInputFieldFragment = gql27(_templateObject27());
// ../internal/src/components/egds-text-input/egds-text-input-field.tsx
var fragment24 = gql28(_templateObject28(), __EGDSInputFieldFragment);
var EGDSTextInputField = React27.forwardRef(function (props, ref) {
  var data = props.data,
    refDup = props.ref,
    rest = _object_without_properties(props, ["data", "ref"]);
  var disabled = data.disabled,
    egdsElementId = data.egdsElementId,
    instructions = data.instructions,
    label = data.label,
    placeholder = data.placeholder,
    readOnly = data.readOnly,
    required = data.required,
    leftIcon = data.leftIcon;
  return /* @__PURE__ */React27.createElement(UitkTextInput, _object_spread({
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : void 0,
    instruction: instructions !== null && instructions !== void 0 ? instructions : void 0,
    label: label,
    name: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : void 0,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0,
    readOnly: readOnly,
    required: required !== null && required !== void 0 ? required : false,
    icon: (leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.token) || void 0,
    domRef: ref !== null && ref !== void 0 ? ref : null
  }, rest));
});
EGDSTextInputField.fragment = fragment24;
EGDSTextInputField.displayName = "EGDSTextInputField";
// src/components/answering-traveller-questions-content-search/__private/__fragments/search-input-field.tsx
var fragment25 = gql29(_templateObject29(), EGDSTextInputField.fragment, __TravellerClickActionFragment);
var SearchInputField = React28.forwardRef(function (props, ref) {
  var data = props.data,
    handleChange = props.handleChange,
    handleClear = props.handleClear,
    inputValue = props.inputValue,
    _props_inputSize = props.inputSize,
    inputSize = _props_inputSize === void 0 ? 100 : _props_inputSize,
    handleOnKeyDown = props.handleOnKeyDown;
  var textInput = data.textInput,
    inputAction = data.inputAction;
  var track = useEgClickstream2();
  var trackUisPrime = useClickTracker3();
  var handleTrackRequest = useCallback7(function (clickstreamData) {
    var _clickstreamData_clickEvent = clickstreamData.clickEvent,
      eventName = _clickstreamData_clickEvent.eventName,
      eventType = _clickstreamData_clickEvent.eventType,
      eventVersion = _clickstreamData_clickEvent.eventVersion,
      actionLocation = _clickstreamData_clickEvent.actionLocation;
    var clickstreamEventData = {
      eventName: eventName,
      eventVersion: eventVersion,
      eventType: eventType,
      actionLocation: actionLocation || ""
    };
    var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
    track(clickstreamEvent);
  }, [track]);
  var handleTrackRequestWithUisPrime = useCallback7(function (clickAnalytics) {
    trackUisPrime(clickAnalytics.referrerId, clickAnalytics.linkName, false);
  }, [trackUisPrime]);
  var handleClickandFocus = useCallback7(function (event) {
    if (inputAction === null || inputAction === void 0 ? void 0 : inputAction.clickAnalytics) {
      handleTrackRequestWithUisPrime(inputAction.clickAnalytics);
    } else if (inputAction === null || inputAction === void 0 ? void 0 : inputAction.clickEvent) {
      handleTrackRequest(inputAction);
    }
  }, [inputAction, handleTrackRequest, handleTrackRequestWithUisPrime]);
  return /* @__PURE__ */React28.createElement(React28.Fragment, null, textInput && /* @__PURE__ */React28.createElement(EGDSTextInputField, {
    data: textInput,
    size: inputSize,
    hasClearButton: true,
    value: inputValue,
    onChange: handleChange,
    onFocus: handleClickandFocus,
    handleClear: handleClear,
    onKeyDown: handleOnKeyDown,
    type: "search",
    ref: ref !== null && ref !== void 0 ? ref : null
  }));
});
SearchInputField.fragment = fragment25;
SearchInputField.displayName = "SearchInputField";
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-input.tsx
var fragment26 = gql30(_templateObject30(), SearchButton.fragment, SearchInputField.fragment);
var TravellerSearchInput = React29.forwardRef(function (props, ref) {
  var data = props.data,
    handleSubmit = props.handleSubmit,
    searchTermValue = props.searchTermValue,
    _props_showSubmitButton = props.showSubmitButton,
    showSubmitButton = _props_showSubmitButton === void 0 ? true : _props_showSubmitButton,
    handleSearchTermClear = props.handleSearchTermClear,
    inputSize = props.inputSize;
  var searchButton = data.searchButton,
    searchInputField = data.searchInputField;
  var _useState3 = _sliced_to_array(useState3(), 2),
    inputValue = _useState3[0],
    setInputValue = _useState3[1];
  var _useState31 = _sliced_to_array(useState3(true), 2),
    isSubmitDisabled = _useState31[0],
    setSubmitDisabled = _useState31[1];
  var track = useEgClickstream3();
  var trackUisPrime = useClickTracker4();
  var handleTrackRequest = useCallback8(function (clickstreamData) {
    var _clickstreamData_clickEvent = clickstreamData.clickEvent,
      eventName = _clickstreamData_clickEvent.eventName,
      eventType = _clickstreamData_clickEvent.eventType,
      eventVersion = _clickstreamData_clickEvent.eventVersion,
      actionLocation = _clickstreamData_clickEvent.actionLocation;
    var clickstreamEventData = {
      eventName: eventName,
      eventVersion: eventVersion,
      eventType: eventType,
      actionLocation: actionLocation || ""
    };
    var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
    track(clickstreamEvent);
  }, [track]);
  var handleTrackRequestWithUisPrime = useCallback8(function (clickAnalytics) {
    trackUisPrime(clickAnalytics.referrerId, clickAnalytics.linkName, false);
  }, [trackUisPrime]);
  var handleSearchSubmit = useCallback8(function () {
    if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim()) !== searchTermValue) {
      var _searchButton_searchAction, _searchButton_searchAction1;
      if (searchButton === null || searchButton === void 0 ? void 0 : (_searchButton_searchAction = searchButton.searchAction) === null || _searchButton_searchAction === void 0 ? void 0 : _searchButton_searchAction.clickAnalytics) {
        handleTrackRequestWithUisPrime(searchButton.searchAction.clickAnalytics);
      } else if (searchButton === null || searchButton === void 0 ? void 0 : (_searchButton_searchAction1 = searchButton.searchAction) === null || _searchButton_searchAction1 === void 0 ? void 0 : _searchButton_searchAction1.clickEvent) {
        handleTrackRequest(searchButton.searchAction);
      }
    }
    handleSubmit(inputValue);
  }, [handleSubmit, inputValue, searchButton, handleTrackRequest, handleTrackRequestWithUisPrime, searchTermValue]);
  var handleOnKeyDown = function (event) {
    if (event.key === "Enter") {
      handleSearchSubmit();
      event.preventDefault();
    }
  };
  var handleChange = useCallback8(function (event) {
    var value = event.target.value;
    setInputValue(value);
  }, [setInputValue]);
  useEffect3(function () {
    if (searchTermValue === null || searchTermValue === void 0 ? void 0 : searchTermValue.trim().length) {
      setInputValue(searchTermValue);
    }
  }, [searchTermValue]);
  useEffect3(function () {
    if (inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim().length) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [inputValue]);
  return /* @__PURE__ */React29.createElement(UitkLayoutFlex5, {
    space: "three"
  }, searchInputField && /* @__PURE__ */React29.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */React29.createElement(SearchInputField, {
    data: searchInputField,
    inputValue: inputValue,
    handleChange: handleChange,
    handleClear: handleSearchTermClear,
    handleOnKeyDown: handleOnKeyDown,
    inputSize: inputSize,
    ref: ref !== null && ref !== void 0 ? ref : null
  })), searchButton && showSubmitButton && /* @__PURE__ */React29.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */React29.createElement(SearchButton, {
    data: searchButton,
    handleOnClick: handleSearchSubmit,
    ref: null,
    isSubmitDisabled: isSubmitDisabled
  })));
});
TravellerSearchInput.fragment = fragment26;
TravellerSearchInput.displayName = "TravellerSearchInput";
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-content-dialog.tsx
var fragment27 = gql31(_templateObject31(), DialogToolbar.fragment, TravellerSearchInput.fragment, __TravellerClickActionFragment, ErrorMessage.fragment);
var TravellerSearchContentDialog = function (param) {
  var data = param.data,
    _param_triggerRef = param.triggerRef,
    triggerRef = _param_triggerRef === void 0 ? null : _param_triggerRef,
    isDialogOpen = param.isDialogOpen,
    closeDialog = param.closeDialog,
    searchTermValue = param.searchTermValue;
  var _useState4 = _sliced_to_array(useState4(""), 2),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  var _useState41 = _sliced_to_array(useState4(false), 2),
    isSearchError = _useState41[0],
    setSearchError = _useState41[1];
  var _useTravellerSearchInputs = useTravellerSearchInputs(),
    dialogId = _useTravellerSearchInputs.dialogId,
    dialogKey = _useTravellerSearchInputs.dialogKey,
    inputs = _useTravellerSearchInputs.inputs;
  var _useDialog2 = _sliced_to_array(useDialog2(dialogId, dialogKey), 3),
    DialogComponent = _useDialog2[2];
  var viewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  });
  var track = useEgClickstream4();
  var trackUisPrime = useClickTracker5();
  var isViewSizeSmall = viewSize <= defaultViewSizes[ViewSizes.SMALL];
  var dialogToolbar = data.dialogToolbar,
    travellerSearchInput = data.travellerSearchInput,
    errorMessage = data.errorMessage,
    loadingStateAccessibility = data.loadingStateAccessibility,
    closeAction = data.closeAction,
    impressionAnalytics = data.impressionAnalytics;
  var impressionAnalyticsDataFromatter = function (analyticsData) {
    if (!(analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.clickEvent)) {
      return {};
    }
    var _analyticsData_clickEvent = analyticsData.clickEvent,
      eventName = _analyticsData_clickEvent.eventName,
      eventType = _analyticsData_clickEvent.eventType,
      eventVersion = _analyticsData_clickEvent.eventVersion,
      actionLocation = _analyticsData_clickEvent.actionLocation;
    var clickstreamEventData = {
      eventName: eventName,
      eventVersion: eventVersion,
      eventType: eventType,
      actionLocation: actionLocation || ""
    };
    return clickstreamEventBuilder(clickstreamEventData);
  };
  var onDialogClose = useCallback9(function () {
    if (closeAction === null || closeAction === void 0 ? void 0 : closeAction.clickAnalytics) {
      trackUisPrime(closeAction.clickAnalytics.referrerId, closeAction.clickAnalytics.linkName, true);
    } else if (closeAction === null || closeAction === void 0 ? void 0 : closeAction.clickEvent) {
      var _closeAction_clickEvent = closeAction.clickEvent,
        eventName = _closeAction_clickEvent.eventName,
        eventType = _closeAction_clickEvent.eventType,
        eventVersion = _closeAction_clickEvent.eventVersion,
        actionLocation = _closeAction_clickEvent.actionLocation;
      var clickstreamEventData = {
        eventName: eventName,
        eventVersion: eventVersion,
        eventType: eventType,
        actionLocation: actionLocation || ""
      };
      var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
      track(clickstreamEvent);
    }
    closeDialog();
  }, [closeDialog, closeAction, track, trackUisPrime]);
  var handleSubmit = useCallback9(function (searchTermInputValue) {
    setSearchTerm(searchTermInputValue);
  }, [setSearchTerm]);
  var handleSearchError = useCallback9(function () {
    setSearchError(true);
  }, [setSearchError]);
  var resetSearchTerm = useCallback9(function () {
    if (searchTerm) {
      setSearchTerm("");
    }
  }, [searchTerm, setSearchTerm]);
  useEffect4(function () {
    if (searchTermValue) {
      setSearchTerm(searchTermValue);
    }
  }, [searchTermValue]);
  var MemoisedTravellerSearch = useMemo4(function () {
    return /* @__PURE__ */React30.createElement(TravellerSearch, {
      inputs: inputs,
      searchTerm: searchTerm,
      onSearchError: handleSearchError,
      loadingStateAccessibility: loadingStateAccessibility
    });
  }, [searchTerm, handleSearchError, inputs, loadingStateAccessibility]);
  var dialogComponent = /* @__PURE__ */React30.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React30.createElement(DialogComponent, null, /* @__PURE__ */React30.createElement(UitkSheet, {
    returnFocusOnClose: true,
    triggerRef: triggerRef,
    isVisible: isDialogOpen,
    type: isViewSizeSmall ? "full" : "centered",
    height: isViewSizeSmall ? void 0 : 594
  }, dialogToolbar && /* @__PURE__ */React30.createElement(DialogToolbar, {
    data: dialogToolbar,
    closeDialog: onDialogClose
  }), /* @__PURE__ */React30.createElement(UitkSheetContent, null, /* @__PURE__ */React30.createElement(UitkLayoutFlex6, {
    blockSize: "full_size",
    wrap: "nowrap",
    direction: "column"
  }, isSearchError ? /* @__PURE__ */React30.createElement(UitkLayoutFlexItem7, null, errorMessage && /* @__PURE__ */React30.createElement(ErrorMessage, {
    data: errorMessage
  })) : /* @__PURE__ */React30.createElement(React30.Fragment, null, travellerSearchInput && /* @__PURE__ */React30.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */React30.createElement(TravellerSearchInput, {
    data: travellerSearchInput,
    handleSubmit: handleSubmit,
    searchTermValue: searchTerm,
    ref: null,
    handleSearchTermClear: resetSearchTerm
  })), /* @__PURE__ */React30.createElement(UitkLayoutFlexItem7, {
    alignSelf: "stretch"
  }, /* @__PURE__ */React30.createElement("div", {
    "aria-live": "polite"
  }, MemoisedTravellerSearch))))))));
  return (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.clickEvent) ? /* @__PURE__ */React30.createElement(EgClickstreamImpressionTracker2, {
    eventData: impressionAnalyticsDataFromatter(impressionAnalytics)
  }, dialogComponent) : dialogComponent;
};
TravellerSearchContentDialog.fragment = fragment27;
TravellerSearchContentDialog.displayName = "TravellerSearchContentDialog";
// src/components/answering-traveller-questions-content-search/__private/__fragments/traveller-search-content.tsx
var fragment28 = gql32(_templateObject32(), TravellerSearchInput.fragment, TravellerSearchContentDialog.fragment, __TravellerClickActionFragment, EGDSStandardBadge.fragment);
var TravellerSearchContent = function (param) {
  var data = param.data;
  var _useState5 = _sliced_to_array(useState5(""), 2),
    searchTerm = _useState5[0],
    setSearchTerm = _useState5[1];
  var _useTravellerSearchInputs = useTravellerSearchInputs(),
    dialogId = _useTravellerSearchInputs.dialogId,
    dialogKey = _useTravellerSearchInputs.dialogKey;
  var _useDialog3 = _sliced_to_array(useDialog3(dialogId, dialogKey), 2),
    isDialogOpen = _useDialog3[0],
    dialogActions = _useDialog3[1];
  var searchDialogTriggerRef = useRef(null);
  var heading = data.heading,
    paragraph = data.paragraph,
    travellerSearchInput = data.travellerSearchInput,
    travellerSearchDialog = data.travellerSearchDialog,
    badge = data.badge;
  var handleSubmit = useCallback10(function (searchTermValue) {
    setSearchTerm(searchTermValue);
    dialogActions.openDialog();
  }, [setSearchTerm, dialogActions]);
  var onClose = useCallback10(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  var resetSearchTerm = useCallback10(function () {
    if (searchTerm) {
      setSearchTerm("");
    }
  }, [searchTerm, setSearchTerm]);
  var MemoisedTravellerSearchInput = useMemo5(function () {
    return /* @__PURE__ */React31.createElement(React31.Fragment, null, travellerSearchInput && /* @__PURE__ */React31.createElement(UitkLayoutGridItem, {
      colSpan: 1
    }, /* @__PURE__ */React31.createElement(TravellerSearchInput, {
      data: travellerSearchInput,
      handleSubmit: handleSubmit,
      ref: searchDialogTriggerRef,
      handleSearchTermClear: resetSearchTerm,
      inputSize: 200
    })));
  }, [travellerSearchInput, handleSubmit, searchDialogTriggerRef, resetSearchTerm]);
  return /* @__PURE__ */React31.createElement(EGDSLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React31.createElement(UitkSpacing7, {
    margin: {
      blockstart: "six",
      blockend: "six",
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    },
    padding: {
      block: "six",
      large: {
        inline: "six"
      },
      extra_large: {
        inline: "six"
      }
    }
  }, /* @__PURE__ */React31.createElement(UitkCard, {
    border: true,
    backgroundTheme: badge ? "highlight" : void 0
  }, /* @__PURE__ */React31.createElement(UitkCardContentSection, null, travellerSearchDialog && isDialogOpen ? /* @__PURE__ */React31.createElement(TravellerSearchContentDialog, {
    data: travellerSearchDialog,
    triggerRef: searchDialogTriggerRef,
    closeDialog: onClose,
    isDialogOpen: isDialogOpen,
    searchTermValue: searchTerm
  }) : null, /* @__PURE__ */React31.createElement(UitkLayoutGrid, {
    space: "three",
    columns: 1,
    "data-testid": "traveller-qa-section"
  }, /* @__PURE__ */React31.createElement(UitkLayoutGridItem, {
    colSpan: 1
  }, /* @__PURE__ */React31.createElement(EGDSLayoutFlex2, {
    justifyContent: "space-between"
  }, heading && /* @__PURE__ */React31.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React31.createElement(UitkHeading2, {
    tag: "h2",
    size: 4
  }, heading)), badge && /* @__PURE__ */React31.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React31.createElement(EGDSStandardBadge, {
    data: badge,
    size: "large",
    theme: "emphasis"
  })))), paragraph && /* @__PURE__ */React31.createElement(UitkLayoutGridItem, {
    colSpan: 1
  }, /* @__PURE__ */React31.createElement("div", null, /* @__PURE__ */React31.createElement(UitkParagraph3, {
    size: 1
  }, paragraph))), MemoisedTravellerSearchInput)))));
};
TravellerSearchContent.fragment = fragment28;
TravellerSearchContent.displayName = "TravellerSearchContent";
// src/components/answering-traveller-questions-content-search/answering-traveller-questions-loading-placeholder.tsx
import React32 from "react";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var LineSkeletonPlaceholder = function (param) {
  var colSpan = param.colSpan,
    colStart = param.colStart;
  return /* @__PURE__ */React32.createElement(EGDSLayoutGridItem, {
    colSpan: colSpan,
    colStart: colStart
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlex3, {
    space: "three",
    direction: "column"
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React32.createElement(EGDSLineSkeleton, {
    animation: true
  })), /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React32.createElement(EGDSLineSkeleton, {
    animation: true,
    type: "secondary"
  }))));
};
var BlockSkeletonPlaceholder = function (param) {
  var _param_colSpan = param.colSpan,
    colSpan = _param_colSpan === void 0 ? 1 : _param_colSpan,
    _param_colStart = param.colStart,
    colStart = _param_colStart === void 0 ? 1 : _param_colStart,
    columns = param.columns;
  return /* @__PURE__ */React32.createElement(EGDSLayoutGrid, {
    columns: columns
  }, /* @__PURE__ */React32.createElement(EGDSLayoutGridItem, {
    colSpan: colSpan,
    colStart: colStart
  }, /* @__PURE__ */React32.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R4_1
  }, /* @__PURE__ */React32.createElement(EGDSBlockSkeleton, {
    type: "rounded"
  }))));
};
var AnsweringTravellerQuestionsLoadingPlaceholder = function () {
  return /* @__PURE__ */React32.createElement(EGDSSpacing3, {
    padding: {
      block: "six",
      large: {
        inline: "six"
      }
    }
  }, /* @__PURE__ */React32.createElement(EGDSCard2, {
    overflow: false,
    border: true
  }, /* @__PURE__ */React32.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React32.createElement(EGDSLayoutGrid, {
    space: "three",
    columns: 1
  }, /* @__PURE__ */React32.createElement(LineSkeletonPlaceholder, {
    colSpan: 1,
    colStart: 1
  }), /* @__PURE__ */React32.createElement(EGDSLayoutGridItem, {
    colSpan: 1,
    colStart: 1
  }, /* @__PURE__ */React32.createElement(Viewport, null, /* @__PURE__ */React32.createElement(ViewSmall, null, /* @__PURE__ */React32.createElement(BlockSkeletonPlaceholder, {
    columns: 1
  })), /* @__PURE__ */React32.createElement(ViewMedium, null, /* @__PURE__ */React32.createElement(BlockSkeletonPlaceholder, {
    columns: 3
  }))))))));
};
AnsweringTravellerQuestionsLoadingPlaceholder.displayName = "AnsweringTravellerQuestionsLoadingPlaceholder";
// src/components/answering-traveller-questions-content-search/answering-traveller-questions-content-search.tsx
var __Query2 = gql33(_templateObject33(), TravellerSearchContent.fragment);
var AnsweringTravellerQuestionsContentSearch = function (props) {
  var _answeringTravellerQuestions_impressionAnalytics;
  var skipSsr = props.skipSsr,
    inputs = props.inputs,
    _props_isNestDialog = props.isNestDialog,
    isNestDialog = _props_isNestDialog === void 0 ? false : _props_isNestDialog,
    _props_dialogId = props.dialogId,
    dialogId = _props_dialogId === void 0 ? TRAVELLER_SEARCH_DIALOG_ID : _props_dialogId;
  var context = useBexApi3().context;
  var variables = {
    context: context
  };
  var _useQuery = useQuery(__Query2, {
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: "cache-first"
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var impressionAnalyticsDataFromatter = useCallback11(function (analyticsData) {
    if (!(analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.clickEvent)) {
      return {};
    }
    var _analyticsData_clickEvent = analyticsData.clickEvent,
      eventName = _analyticsData_clickEvent.eventName,
      eventType = _analyticsData_clickEvent.eventType,
      eventVersion = _analyticsData_clickEvent.eventVersion,
      actionLocation = _analyticsData_clickEvent.actionLocation;
    var clickstreamEventData = {
      eventName: eventName,
      eventVersion: eventVersion,
      eventType: eventType,
      actionLocation: actionLocation || ""
    };
    var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
    return clickstreamEvent;
  }, []);
  var travellerSearchInputs = React33.useMemo(function () {
    var dialogKey = isNestDialog ? "pwaDialogNested" : "pwaDialog";
    return {
      inputs: inputs,
      dialogKey: dialogKey,
      dialogId: dialogId
    };
  }, [inputs, isNestDialog, dialogId]);
  if (loading) {
    return /* @__PURE__ */React33.createElement(AnsweringTravellerQuestionsLoadingPlaceholder, null);
  }
  if (error || !data || !data.answeringTravellerQuestions) {
    return null;
  }
  var answeringTravellerQuestions = data.answeringTravellerQuestions;
  var travellerSearchContent = /* @__PURE__ */React33.createElement(TravellerSearchInputsContext.Provider, {
    value: travellerSearchInputs
  }, /* @__PURE__ */React33.createElement(TravellerSearchContent, {
    data: answeringTravellerQuestions
  }));
  if (answeringTravellerQuestions === null || answeringTravellerQuestions === void 0 ? void 0 : (_answeringTravellerQuestions_impressionAnalytics = answeringTravellerQuestions.impressionAnalytics) === null || _answeringTravellerQuestions_impressionAnalytics === void 0 ? void 0 : _answeringTravellerQuestions_impressionAnalytics.clickEvent) {
    return /* @__PURE__ */React33.createElement(EgClickstreamImpressionTracker3, {
      eventData: impressionAnalyticsDataFromatter(answeringTravellerQuestions === null || answeringTravellerQuestions === void 0 ? void 0 : answeringTravellerQuestions.impressionAnalytics)
    }, travellerSearchContent);
  }
  return travellerSearchContent;
};
AnsweringTravellerQuestionsContentSearch.displayName = "sharedui-AnsweringTravellerQuestionsContentSearch";
export { AnsweringTravellerQuestionsContentSearch, IdentifierType };